import { Card, CardContent, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

export default function GeneralInstruction({ instructionList }) {
  return (
    <Card style={{ marginTop: 15 }}>
      <CardContent>
        <Typography variant="subtitle1">General Instructions</Typography>
        <ul style={{ marginTop: 15, marginLeft: 20 }}>
          {instructionList.map((il, i) => (
            <li key={i} style={{ marginTop: 5 }}>
              {il}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}

GeneralInstruction.propTypes = {
  instructionList: PropTypes.array
};
